module.exports = {
  name: 'options', base: 'fields', prototype: {
    element_selector: '.options'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/options.js
 ** module id = 23
 ** module chunks = 0
 **/